import React, { useState } from "react";
import Card from "./Card";

const ArticleTabs = ({ articles, filter, totalPages }) => {
  const [content, setContent] = useState(articles);
  const [page, setPage] = useState(1);

  const url = window.location.pathname;
  const axios = require('axios');
  axios.defaults.headers.common['Accept'] = 'application/json';

  const handleSubmit = e => {
    e.preventDefault();

    let nextPage = page + 1;

    axios.get(url, {
      params: {
        page: nextPage,
        filter: filter
      }
    }, { headers: {'Content-Type': 'text/javascript'} })
    .then(function (response) {
      setContent([...content,...response.data]);
      setPage(nextPage);
    })
    .catch(function (error) {
      console.log(error);
    });
  };

  return (
    <div className="blog-articles-container">
      { content.map((item, index) =>
        <Card article={item} key={index} reversed={index % 2 != 0} />
      )}

      <div className="promos-container__more">
        { page < totalPages  &&
          <a className="button button_large" onClick={handleSubmit} rel="next">Загрузить еще</a>
        }
        { totalPages == 0 &&
          <div className="promos-container__no-results">Нет результатов</div>
        }
      </div>
    </div>
  )
}

export default ArticleTabs;
